import { render, staticRenderFns } from "./OndemandOTP.vue?vue&type=template&id=4835b444"
import script from "./OndemandOTP.vue?vue&type=script&lang=js"
export * from "./OndemandOTP.vue?vue&type=script&lang=js"
import style0 from "./OndemandOTP.vue?vue&type=style&index=0&id=4835b444&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports